import i18next from "../../../../../../i18n";

i18next.addResourceBundle("en", "DocumentTableSavebar", {
    more: "More",
    apply: "Apply",

    set_owner_button: "Set owner",
    set_owner_text_one: "Choose owner for {{count}} item",
    set_owner_text_other: "Choose owner for {{count}} items",
    set_tags_button: "Set tags",
    set_tags_text_one: "Set tags for {{count}} item",
    set_tags_text_other: "Set tags for {{count}} items",

    set_relevance_button: "Set relevance",
    set_relevance_text: "Set relevance for {{count}} items",
    relevant: "Relevant",
    not_relevant: "Not relevant",
    mark_not_relevant: "Mark as not relevant",
    success_message: "Document updated successfully",
    document_table_savebar_actions: "Select action",
    document_table_action_mark_not_relevant_one:
        "Mark {{count}} document as not relevant",
    document_table_action_mark_not_relevant_other:
        "Mark {{count}} documents as not relevant",
});

i18next.addResourceBundle("fr", "DocumentTableSavebar", {
    more: "Plus",
    apply: "Enregistrer",

    set_owner_button: "Assigner",
    set_tags_text: "Assigner {{count}} éléments",

    set_relevance_button: "Set relevance",
    set_relevance_text: "Set relevance for {{count}} items",
    mark_not_relevant: "Définir comme non pertinent",
    success_message: "Document mis à jour avec succès",
    set_owner_text_one: "Assigner un propriétaire à {{count}} élément",
    set_owner_text_other: "Assigner un propriétaire à {{count}} éléments",
    set_tags_button: "Assigner des tags",
    set_tags_text_one: "Assigner des tags à {{count}} élément",
    set_tags_text_other: "Assigner des tags à {{count}} éléments",
    document_table_savebar_actions: "Choisir une action",
    document_table_action_mark_not_relevant_one:
        "Marquer {{count}} document comme non pertinent",
    document_table_action_mark_not_relevant_other:
        "Marquer {{count}} documents comme non pertinents",
});
